import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { toQueryParams } from 'helpers/api';
import cookie from 'react-cookies';

export const servicesApi = createApi({
  reducerPath: 'servicesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/services`,
    prepareHeaders: headers => {
      headers.set('Authorization', `Bearer ${cookie.load('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getACICExportFile: builder.query({
      queryFn: async (params, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: `/acic/export_file`,
          responseHandler: async response => {
            const countHeader = response.headers.get('X-ACIC-Skipped-Count');
            const skippedCount = countHeader ? parseInt(countHeader, 10) : 0;
            const blob = await response.blob();
            return { blob, skippedCount: Number.isFinite(skippedCount) ? skippedCount : 0 };
          },
          cache: 'no-cache',
        });
        if (result.error) {
          return { error: result.error };
        }
        const payload = result.data ?? {};
        if (payload.blob) {
          saveAs(payload.blob, 'acic_export_file.xml');
        }
        return { data: { skippedCount: payload.skippedCount ?? 0 } };
      },
    }),
    signACICResultUpload: builder.query({
      query: params => `/acic/sign_result_upload?${toQueryParams(params)}`,
      transformResponse: response => response.result,
    }),
  }),
});

export const { useLazyGetACICExportFileQuery, useLazySignACICResultUploadQuery } = servicesApi;
